import { boolean, object, string } from 'yup'

const VideoConsultationSchema = object().shape({
  title: string().trim(),
  first_name: string()
    .required('First name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'First name can only contain letters and basic punctuation',
    )
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must be at most 50 characters')
    .trim(),
  last_name: string()
    .required('Last name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'Last name can only contain letters and basic punctuation',
    )
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must be at most 50 characters')
    .trim(),
  email: string()
    .required('Email is required')
    .matches(
      /^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/,
      'Email must be a valid email address',
    )
    .max(255)
    .trim(),
  tel: string()
    .matches(/^\d{7,11}$/, {
      message: 'Please enter a valid telephone number',
      excludeEmptyString: true,
    })
    .trim(),
  model: string().required('Model is a required field').trim(),
  date_input: string().required('Date and time are required').trim(),
  time: string().required('').trim(),
  notes: string().trim(),
  type: string().trim(),
  consent: object({
    user: boolean(),
  }),
  response_code: string().uppercase().trim(),
  campaign_response_code: string().uppercase().trim(),
  campaign_code: string().uppercase().trim(),
  crm_response_source: string().trim(),
  dealer_name: string(),
  is_dealer: boolean(),
  dealer: string().required('Please select an option'),
  is_lexus: boolean(),
})

export default VideoConsultationSchema
